<div [appEnforcePermission]="authConfig.investigationReportsList" #investigationReportsList="appEnforcePermission">
</div>
<div [appEnforcePermission]="authConfig.investigationReportsCreate" #investigationReportsCreate="appEnforcePermission">
</div>
<div [appEnforcePermission]="authConfig.investigationReportsDelete" #investigationReportsDelete="appEnforcePermission">
</div>
<div [appEnforcePermission]="authConfig.investigationReportsDeleteOwn"
  #investigationReportsDeleteOwn="appEnforcePermission"></div>
<kendo-drawer #drawer [width]="-1" [mini]="false" [mode]="'overlay'" [expanded]="true" [position]="'end'"
  [animation]="true">
  <ng-template kendoDrawerTemplate>
    <section class="content-part safe-area-padding-top">
      <div class="header m-16">
        <span>
          <h6>Investigation Reports</h6>
          <p> Investigation ID: {{investigation?.nefcoNumber || 'Unassigned'}}</p>
        </span>
        <button class="close-action" kendoButton themeColor="light" fillMode="solid"
          [iconClass]="drawer.expanded && 'fa-solid fa-close'" (click)="close()"></button>
      </div>
      <hr class="divider-line" />
      <div class="p-16">
        <kendo-gridlayout class="mt-16" [rows]="['auto']" [gap]="{ rows: 5, cols: 16 }"
          [cols]="['repeat(1,minmax(0,1fr))']">
          <kendo-gridlayout-item>
            <div class="kendo-formfield">
              <kendo-label [for]="reportType" text="Report Type" class="asterisk"></kendo-label>
              <kendo-dropdownlist #reportType [data]="reportTypes" textField="name" valueField="id" fillMode="outline"
                [valuePrimitive]="true" [defaultItem]="{ id: null, name: 'Select report type' }"
                [(ngModel)]="selectedReportTypeId" [popupSettings]="{
                      appendTo: 'root',
                      animate: false,
                      width: 250
                    }">
                <ng-template kendoDropDownListValueTemplate let-dataItem>
                  <span *ngIf="!dataItem?.id" class="placeholder">
                    {{ dataItem.name }}
                  </span>
                  <span *ngIf="dataItem?.id" class="not-placeholder">
                    {{ dataItem.name }}
                  </span>
                </ng-template>
                <ng-template kendoDropDownListNoDataTemplate> </ng-template>
              </kendo-dropdownlist>
            </div>
          </kendo-gridlayout-item>
        </kendo-gridlayout>
        <kendo-button kendoButton themeColor="primary" [disabled]="!selectedReportTypeId" fillMode="solid" size="large"
          style="width: 100%;" (click)="prefillModal()">
          Create Report
        </kendo-button>
      </div>
      <ng-container *ngIf="investigationReportsList?.enabled">
        <section class="detail-wrapper">
          <kendo-card *ngFor="let dataItem of reports" [width]="''" [ngStyle]="{'border-radius': '10px'}">
            <kendo-card-header>
              {{dataItem?.title}}
            </kendo-card-header>
            <kendo-card-body>
              <div class="column">
                <div class="equal">
                  <h6 class="kendo-caption"><small>Created By</small></h6>
                  <h6 class="kendo-caption-body">
                    {{(dataItem.CreatedBy | fullName) || '-'}}
                  </h6>
                </div>
                <div class="equal">
                  <h6 class="kendo-caption"><small>Status</small></h6>
                  <h6 class="kendo-caption-body">
                    <app-report-status-icon-kendo
                      [snapshot]="dataItem?.History?.slice(-1)?.pop()"></app-report-status-icon-kendo>
                  </h6>
                </div>
                <div class="equal">
                  <h6 class="kendo-caption"><small>Last Update</small></h6>
                  <h6 class="kendo-caption-body">
                    {{ dataItem?.updatedAt | customDate : "MM/dd/yyyy" }}
                  </h6>
                </div>
                <div class="equal">
                  <h6 class="kendo-caption"><small>Updated By</small></h6>
                  <h6 class="kendo-caption-body">
                    {{ dataItem?.History?.slice(-1)?.pop()?.CreatedBy | fullName }}
                  </h6>
                </div>
                <div class="equal">
                  <h6 class="kendo-caption"><small>Editor</small></h6>
                  <h6 class="kendo-caption-body">
                    {{(dataItem?.Editor | fullName) || '-'}}
                  </h6>
                </div>
                <div class="equal">
                  <h6 class="kendo-caption"><small>Actions</small></h6>
                  <h6 class="kendo-caption-body">
                    <a (click)="deleteDraft(dataItem)" target="_blank"
                      *ngIf="[IInvestigationReportStatus.Draft].includes(dataItem?.Status.status) && (investigationReportsDelete?.enabled || (investigationReportsDeleteOwn?.enabled && dataItem?.CreatedBy?.id === user?.id))">
                      <i class="fa-solid fa-trash"></i>
                    </a>
                  </h6>
                </div>

              </div>
            </kendo-card-body>
          </kendo-card>
        </section>
      </ng-container>
    </section>
  </ng-template>
